import { apiGet, apiPost } from './api';

export const postLunchMenu = (lunch, onSuccess) => apiPost('/lunch', lunch, onSuccess);

export const getCurrentLunchMenu = (onSuccess) => apiGet('/lunch/current', onSuccess);
